module.exports = __webpack_public_path__ + "img/recently_deleted.b809e885.svg";